import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';

import { AlertService } from '../../services/alert.service';
import { CommunityService } from '../../services/community.service';
import { ProgressIndicatorService } from '../../services/progress-indicator.service';

@Component({
    selector: 'community-new-comment',
    templateUrl: './community-new-comment.component.html',
    styleUrls: ['./community-new-comment.component.scss']
})
export class CommunityNewCommentComponent implements OnInit, OnDestroy {

    @Input()
    message: any;

    @Output('refreshComments')
    refreshCommentEventEmitter = new EventEmitter<void>();

    constructor(
        private alertService: AlertService,
        private progressIndicatorService: ProgressIndicatorService,
        private communityService: CommunityService
    ) {
    }

    ngOnInit() {
    }

    ngOnDestroy() {
    }

    postComment(text: string) {
        this.progressIndicatorService.progress = true;
        this.communityService.postComment(text, this.message.id).subscribe({
            next: (value: any) => {
                console.log('CommunityNewCommentComponent.postComment.communityService.postComment.value', value);
                this.progressIndicatorService.progress = false;
                this.alertService.success('Success');
                this.updateMessage();
                this.refreshCommentEventEmitter.emit();
            },
            error: (error: any) => {
                console.log('CommunityNewCommentComponent.postComment.communityService.postComment.error', error);
                this.progressIndicatorService.progress = false;
                this.alertService.danger('Error');
            }
        });
    }

    updateMessage() {
        this.communityService.getMessage(this.message.id).subscribe({
            next: (value: any) => {
                console.log('CommunityNewCommentComponent.updateMessage.communityService.updateMessage.value', value);
                this.message.numLikes = value.numLikes;
                this.message.numComments = value.numComments;
                this.message.numReports = value.numReports;
                this.message.isInLikes = value.isInLikes;
                this.message.isInComments = value.isInComments;
                this.message.deleted = value.deleted;
                this.message.inappropriate = value.inappropriate;
            },
            error: (error: any) => {
                console.log('CommunityNewCommentComponent.updateMessage.communityService.updateMessage.error', error);
            }
        });
    }
}
